import DOMPurify from 'dompurify'

// Allow-list for admin-authored status message bodies. Matches the backend's
// server-side sanitisation; we never trust the stored HTML and re-sanitise on
// render. No style, script, images, or event handlers survive.
const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'p', 'ul', 'ol', 'li', 'a']
const ALLOWED_ATTR = ['href', 'target', 'rel']

// Force every surviving anchor to open safely.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

export const sanitizeBody = (html: string): string =>
  DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // block javascript:, data:, etc. — only http(s)/mailto survive on href
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:)/i
  })

// Plain-text length of rich content, used for the 4000-char body counter.
export const plainTextLength = (html: string): number => {
  const el = document.createElement('div')
  el.innerHTML = sanitizeBody(html)
  return (el.textContent ?? '').length
}
